const StripeLogo = () => {
  return (
    <svg
      width="39"
      height="16"
      viewBox="0 0 39 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_13781_7840)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.4513 8.26734C38.4513 5.53303 37.1269 3.37549 34.5955 3.37549C32.0641 3.37549 30.5154 5.53303 30.5154 8.24598C30.5154 11.4609 32.3311 13.0844 34.9373 13.0844C36.2083 13.0844 37.1696 12.796 37.8959 12.3902V10.254C37.1696 10.6171 36.3365 10.8414 35.2791 10.8414C34.2217 10.8414 33.3245 10.4783 33.207 9.21795H38.4299C38.4299 9.07909 38.4513 8.52369 38.4513 8.26734ZM33.1749 7.25266C33.1749 6.04572 33.9119 5.54371 34.5848 5.54371C35.2577 5.54371 35.9306 6.04572 35.9306 7.25266H33.1749Z"
          fill="#7F7A77"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.3924 3.37549C25.3457 3.37549 24.6728 3.86681 24.299 4.2086L24.1601 3.54638H21.8103V16.0003L24.4805 15.4342L24.4912 12.4115C24.8757 12.6892 25.4418 13.0844 26.3817 13.0844C28.2936 13.0844 30.0346 11.5464 30.0346 8.16054C30.0239 5.06307 28.2616 3.37549 26.3924 3.37549ZM25.7516 10.7346C25.1214 10.7346 24.7476 10.5103 24.4912 10.2326L24.4805 6.27001C24.7582 5.96027 25.1427 5.74665 25.7516 5.74665C26.7235 5.74665 27.3964 6.8361 27.3964 8.2353C27.3964 9.6345 26.7342 10.7346 25.7516 10.7346Z"
          fill="#7F7A77"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.1361 2.74499L20.817 2.16822V0L18.1361 0.566088V2.74499Z"
          fill="#7F7A77"
        />
        <path
          d="M20.817 3.55664H18.1361V12.9024H20.817V3.55664Z"
          fill="#7F7A77"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.2629 4.34708L15.092 3.55669H12.7849V12.9025H15.4551V6.56871C16.0853 5.74628 17.1534 5.89581 17.4845 6.0133V3.55669C17.1427 3.42852 15.8931 3.19354 15.2629 4.34708Z"
          fill="#7F7A77"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.92243 1.23926L7.31628 1.79466L7.3056 10.3501C7.3056 11.9308 8.49118 13.0951 10.072 13.0951C10.9478 13.0951 11.5886 12.9349 11.9411 12.7426V10.5744C11.5993 10.7132 9.91174 11.2045 9.91174 9.62377V5.83205H11.9411V3.55701H9.91174L9.92243 1.23926Z"
          fill="#7F7A77"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.70203 6.27001C2.70203 5.85346 3.04381 5.69324 3.6099 5.69324C4.42165 5.69324 5.44702 5.93891 6.25877 6.37682V3.86681C5.37225 3.51434 4.49642 3.37549 3.6099 3.37549C1.44168 3.37549 -0.000244141 4.50766 -0.000244141 6.39819C-0.000244141 9.34612 4.0585 8.87616 4.0585 10.1472C4.0585 10.6385 3.63126 10.7987 3.03313 10.7987C2.14662 10.7987 1.01444 10.4356 0.117246 9.94425V12.4863C1.11057 12.9135 2.11458 13.0951 3.03313 13.0951C5.25476 13.0951 6.78213 11.995 6.78213 10.0831C6.77145 6.90019 2.70203 7.46628 2.70203 6.27001Z"
          fill="#7F7A77"
        />
      </g>
      <defs>
        <clipPath id="clip0_13781_7840">
          <rect width="38.4513" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default StripeLogo;
